import React from "react";

const ProjectionContext: React.Context<Window> = React.createContext<Window>(window);

export default ProjectionContext;
